import React, { createContext, useContext } from 'react';
import type { DangerPriority } from '@components/common/DangerZoneCard';

export type ConfirmOptions = {
  title: React.ReactNode;
  description?: React.ReactNode;

  /**
   * Visual intent:
   * - 'danger' for destructive actions (delete)
   * - 'warning' for risky actions
   * - 'info' for normal confirmations
   */
  priority?: DangerPriority;

  confirmText?: string;
  cancelText?: string;

  /**
   * If true, the confirm button is auto-focused for faster keyboard workflow.
   * For destructive actions, default is false to reduce accidental confirms.
   */
  autoFocusConfirm?: boolean;
};

export type ConfirmApi = (options: ConfirmOptions) => Promise<boolean>;

export const ConfirmContext = createContext<ConfirmApi | null>(null);

export function useConfirm(): ConfirmApi {
  const ctx = useContext(ConfirmContext);
  if (!ctx) {
    throw new Error('useConfirm must be used within ConfirmProvider');
  }
  return ctx;
}
